import {GroupAnimation} from './animations/GroupAnimation';
import {FadeAnimation} from './animations/FadeAnimation';

export class SlideShow {

    private loop:boolean=true;
    private intervalId:ReturnType<typeof setInterval> | undefined;
    private hasNav:boolean=false;
    private timerStart = 0;
    private timerRemain = 0;

    public static instances:SlideShow[]=[];

    constructor(protected container:JQuery) {
        for (var inst of SlideShow.instances) {
            if (inst.container.is(container)) return inst;
        }
        this.clean();
        this.hasNav = this.container.find('.slideshow-nav').length>0;
        this.loop=<boolean>this.css('loop','true','bool');

        this.goToIndex(0);

        if (this.container.find('.slideshow-toggle').length) {
            this.container.find('.slideshow-toggle').click((ev)=>{
                this.timerChange();
            });
        }

        if (this.hasNav) {
            this.container.find('.slideshow-nav-item').click((ev)=>{
                this.goToIndex($(ev.target).data('index'));
            });
        }

        this.init();
        this.startTimer();

        SlideShow.instances.push(this);
    }

    private async init() {
        this.container.addClass('slideshow-ready');
    }

    public next() {
        let ce = this.container.find('.slideshow-item.active');
        if (!ce.length) ce=this.container.find('.slideshow-container').children('.slideshow-item').first();
        let ne = ce.next();
        if (!ne.length && this.loop) ne=this.container.find('.slideshow-container').children('.slideshow-item').first();
        this.toElement(ce,ne);
    }

    public prev() {
        let ce = this.container.find('.slideshow-item.active');
        if (!ce.length) ce=this.container.find('.slideshow-container').children('.slideshow-item').first();
        let ne = ce.prev();
        if (!ne.length && this.loop) ne=this.container.find('.slideshow-container').children('.slideshow-item').last();
        this.toElement(ce,ne);
    }

    public async goToIndex(index:number) {
        let ce = this.container.find('.slideshow-item.active');
        if (!ce.length) ce=this.container.find('.slideshow-container').children('.slideshow-item').first();
        let same = ce.data('index') === index;
        let ne = same?ce:ce.siblings('[data-index="' + index + '"]');
        this.stopTimer();
        if (!same || !ce.hasClass('active')) await this.toElement(ce,ne);
        this.startTimer();
    }

    private async toElement(from:JQuery<HTMLElement>, to:JQuery<HTMLElement>) {
        if (!$('body').find(from).length || !$('body').find(to).length) {
            this.stopTimer();
            return;
        }

        new GroupAnimation(
            new FadeAnimation(from).from(1).to(0).on('end', ()=>{from.removeClass('active')}),
            new FadeAnimation(to).from(0).to(1).on('end', ()=>{to.addClass('active')})
        ).play();

        if (this.hasNav) {
            this.container.find('.slideshow-nav-item.active').removeClass('active');
            this.container.find('.slideshow-nav-item[data-index="' + to.data('index') + '"]').addClass('active');
        }
    }

    private startTimer() {
        if (this.intervalId) return;
        let duration=this.css('auto-duration','0','duration');
        if (duration) {
            this.container.addClass('autoplay');
            this.timerStart = Date.now();
            this.intervalId=setInterval(()=>this.autoTimer(),Math.round(Number(duration)));
        }
    }

    private stopTimer() {
        if (this.intervalId) {
            this.container.removeClass('autoplay');
            let duration:number = Math.round(Number(this.css('auto-duration','0','duration')));
            this.timerRemain = duration - (Date.now() - this.timerStart);
            clearInterval(this.intervalId);
            delete this.intervalId;
        }
    }

    private autoTimer() {
        this.timerStart = Date.now();
        this.next();
    }

    private timerChange() {
        if (this.intervalId) {
            this.stopTimer();
        } else {
            if (this.timerRemain > 0) {
                this.container.addClass('autoplay');
                setTimeout(()=>{
                    this.next();
                    this.startTimer();
                },this.timerRemain);
                this.timerRemain = 0;
            } else {
                this.startTimer();
            }
        }
    }

    private keydown(ev:JQuery.TriggeredEvent) {
        if (!document.activeElement) return;
        let e=$(document.activeElement);
        if (e.hasClass('slideshow-item')) {
            if (ev.key=='ArrowLeft') {
                ev.preventDefault();
                let prevItem=e.prev('.slideshow-item');
                if (!prevItem.length) prevItem=e.nextAll('.slideshow-item').last();
                // this.focusSlide(prevItem,-1);
            }
            if (ev.key=='ArrowRight') {
                ev.preventDefault();
                this.next();
            }
            if (ev.key=='ArrowDown') {
                ev.preventDefault();
                this.prev();
            }
            if (ev.key=='Enter') {
                ev.preventDefault();
                // this.thawTabIndex(e);
                // let tabbableElements=this.getTabbableElements(e).filter(':visible').not('[tabindex=-1]');
                // if (tabbableElements.length) {
                //     tabbableElements[0].focus({preventScroll:true});
                // }
                // this.updateTabIndexes();
            }
        }
    }

    private clean() {
        let existingInstances:SlideShow[]=[];
        for (let inst of SlideShow.instances) {
            if ($('body').has(inst.container[0]).length) existingInstances.push(inst);
        }
        SlideShow.instances=existingInstances;
    }

    private css(prop:string,def:string,type:string='string') {
        let r=this.container.css('--slideshow-'+prop);
        if (typeof r=='string') r=r.trim();
        if (r===undefined) r=def;
        if (type=='float') {
            if (r.match(/(%)$/)) return parseFloat(r)/100;
            return parseFloat(r);
        }
        if (type=='duration') {
            if (r.match(/(ms)$/)) return parseFloat(r);
            if (r.match(/(s)$/)) return parseFloat(r)*1000;
            return parseFloat(r);
        }
        if (type=='bool') {
            if (r=='false') return false;
            if (r=='true') return true;
            throw 'Invalid boolean property value for property "'+prop+'"';
        }
        return r;
    }
}

export {};